export default __webpack_public_path__ + "static/media/greendog.732696fe.png";